"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButtonBase = exports.classes = void 0;
const ButtonBase_1 = __importDefault(require("@mui/material/ButtonBase"));
const styles_1 = require("@mui/material/styles");
const PREFIX = "ThumbScrollerButton";
exports.classes = {
    left: `${PREFIX}-left`,
    right: `${PREFIX}-right`,
    icon: `${PREFIX}-icon`
};
exports.StyledButtonBase = (0, styles_1.styled)(ButtonBase_1.default)(({ theme }) => ({
    background: `${theme.colours.black}80`,
    transition: "background ease-in-out 0.25s",
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    color: theme.colours.white,
    width: "42px",
    height: "60px",
    "&:hover": {
        background: `${theme.colours.black}bf`
    },
    [`&.${exports.classes.left}`]: {
        left: 0
    },
    [`&.${exports.classes.right}`]: {
        right: 0
    },
    [`.${exports.classes.icon}`]: {
        color: theme.colours.white,
        height: "auto",
        width: "48px"
    }
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3RodW1iLXNjcm9sbGVyLWJ1dHRvbi9zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsMEVBQWtEO0FBQ2xELGlEQUE4QztBQUU5QyxNQUFNLE1BQU0sR0FBRyxxQkFBcUIsQ0FBQztBQUV4QixRQUFBLE9BQU8sR0FBRztJQUNyQixJQUFJLEVBQUUsR0FBRyxNQUFNLE9BQU87SUFDdEIsS0FBSyxFQUFFLEdBQUcsTUFBTSxRQUFRO0lBQ3hCLElBQUksRUFBRSxHQUFHLE1BQU0sT0FBTztDQUN2QixDQUFDO0FBRVcsUUFBQSxnQkFBZ0IsR0FBRyxJQUFBLGVBQU0sRUFBQyxvQkFBVSxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ2pFLFVBQVUsRUFBRSxHQUFHLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSyxJQUFJO0lBQ3RDLFVBQVUsRUFBRSw4QkFBOEI7SUFDMUMsT0FBTyxFQUFFLGFBQWE7SUFDdEIsY0FBYyxFQUFFLFFBQVE7SUFDeEIsVUFBVSxFQUFFLFFBQVE7SUFDcEIsS0FBSyxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSztJQUMxQixLQUFLLEVBQUUsTUFBTTtJQUNiLE1BQU0sRUFBRSxNQUFNO0lBQ2QsU0FBUyxFQUFFO1FBQ1QsVUFBVSxFQUFFLEdBQUcsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLLElBQUk7S0FDdkM7SUFDRCxDQUFDLEtBQUssZUFBTyxDQUFDLElBQUksRUFBRSxDQUFDLEVBQUU7UUFDckIsSUFBSSxFQUFFLENBQUM7S0FDUjtJQUNELENBQUMsS0FBSyxlQUFPLENBQUMsS0FBSyxFQUFFLENBQUMsRUFBRTtRQUN0QixLQUFLLEVBQUUsQ0FBQztLQUNUO0lBQ0QsQ0FBQyxJQUFJLGVBQU8sQ0FBQyxJQUFJLEVBQUUsQ0FBQyxFQUFFO1FBQ3BCLEtBQUssRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUs7UUFDMUIsTUFBTSxFQUFFLE1BQU07UUFDZCxLQUFLLEVBQUUsTUFBTTtLQUNkO0NBQ0YsQ0FBQyxDQUFDLENBQUMifQ==